import React from "react";

import { observer, inject } from "mobx-react";
import { createPassportModalState } from "../ui/passportModalState";

import Table from "sulu-admin-bundle/components/Table";
import Icon from "sulu-admin-bundle/components/Icon";
import PlayerRow from "./rows/PlayerRow";
import FooterRow from "../../CustomList/FooterRow";
import Modal from "../../../components/CustomList/PassportModal";

const { Header, Body, HeaderCell } = Table;

const localState = createPassportModalState();

const PlayerListTable = inject("selectionStore")(
    observer(({ selectionStore, openModal, props, teamId }) => {
        const filteredPlayers = selectionStore.allPlayers.filter(
            (p) => !p.isDeleted && p.team === teamId,
        );

        const closeHandler = () => {
            localState.close();
        };

        const currentStartingCount = selectionStore.allPlayers.filter(
            (p) => p.team === teamId && p.isStartingPlayer,
        ).length;

        return (
            <>
                <Table>
                    <Header>
                        <HeaderCell>
                            {!props.disabled && (
                                <Icon name="su-plus" onClick={openModal} />
                            )}
                        </HeaderCell>
                        <HeaderCell>Jersey</HeaderCell>
                        <HeaderCell>Name</HeaderCell>
                        <HeaderCell>Pass-Nr.</HeaderCell>
                        <HeaderCell>Status</HeaderCell>
                        <HeaderCell>Captain*</HeaderCell>
                        <HeaderCell>Goalkeeper*</HeaderCell>
                        <HeaderCell>Position (optional)</HeaderCell>
                        <HeaderCell>
                            Starting ({currentStartingCount}/
                            {props.data.numberOfStartingPlayers})
                        </HeaderCell>
                        <HeaderCell>
                            <Icon name="su-trash-alt" />
                        </HeaderCell>
                    </Header>

                    <Body>
                        {filteredPlayers.map((player, index) => (
                            <PlayerRow
                                key={player.contact}
                                player={player}
                                index={index}
                                localState={localState}
                                disabled={props.disabled}
                            />
                        ))}
                    </Body>
                </Table>

                <Modal
                    closeHandler={closeHandler}
                    isOpen={localState.openModal}
                    passportItem={localState.passportInfo}
                    loading={localState.passportLoading}
                />

                <FooterRow
                    noOfSelectedPlayer={filteredPlayers.length}
                    minPlayers={
                        props.data.minNominatedSquadPlayerNo ||
                        props.data.minNominatedCoreSquadPlayers
                    }
                    maxPlayers={props.data.maxNominatedSquadPlayerNo}
                />
            </>
        );
    }),
);

export default PlayerListTable;
